export const list = [
  { country: 'WW', language: [ 'en' ] },
  { country: 'AE', language: [ 'en' ] },
  { country: 'AR', language: [ 'es' ] },
  { country: 'AT', language: [ 'de' ] },
  { country: 'AU', language: [ 'en' ] },
  { country: 'BE', language: [ 'fr', 'nl' ] },
  { country: 'BG', language: [ 'bg' ] },
  { country: 'BR', language: [ 'pt' ] },
  { country: 'CA', language: [ 'en', 'fr' ] },
  { country: 'CH', language: [ 'fr', 'de' ] },
  { country: 'CL', language: [ 'es' ] },
  { country: 'CN', language: [ 'zh' ] },
  { country: 'CO', language: [ 'es' ] },
  { country: 'CR', language: [ 'es' ] },
  { country: 'CZ', language: [ 'cs' ] },
  { country: 'DE', language: [ 'de' ] },
  { country: 'DK', language: [ 'da' ] },
  { country: 'DZ', language: [ 'fr' ] },
  { country: 'EE', language: [ 'et' ] },
  { country: 'EG', language: [ 'en', 'ar' ] },
  { country: 'ES', language: [ 'es' ] },
  { country: 'FI', language: [ 'fi' ] },
  { country: 'FR', language: [ 'fr' ] },
  { country: 'GR', language: [ 'el' ] },
  { country: 'HK', language: [ 'en' ] },
  { country: 'HR', language: [ 'hr' ] },
  { country: 'HU', language: [ 'hu' ] },
  { country: 'ID', language: [ 'en', 'id' ] },
  { country: 'IE', language: [ 'en' ] },
  { country: 'IL', language: [ 'en' ] },
  { country: 'IN', language: [ 'en' ] },
  { country: 'IT', language: [ 'it' ] },
  { country: 'JP', language: [ 'ja' ] },
  { country: 'KR', language: [ 'ko' ] },
  { country: 'KZ', language: [ 'ru' ] },
  { country: 'LT', language: [ 'lt' ] },
  { country: 'LV', language: [ 'lv' ] },
  { country: 'MA', language: [ 'fr' ] },
  { country: 'MY', language: [ 'en' ] },
  { country: 'NG', language: [ 'en' ] },
  { country: 'NL', language: [ 'nl' ] },
  { country: 'NO', language: [ 'no' ] },
  { country: 'NZ', language: [ 'en' ] },
  { country: 'PE', language: [ 'es' ] },
  { country: 'PH', language: [ 'en' ] },
  { country: 'PL', language: [ 'pl' ] },
  { country: 'PT', language: [ 'pt' ] },
  { country: 'RO', language: [ 'ro' ] },
  { country: 'RS', language: [ 'sr' ] },
  { country: 'RU', language: [ 'ru' ] },
  { country: 'SA', language: [ 'en' ] },
  { country: 'SE', language: [ 'sv' ] },
  { country: 'SG', language: [ 'en' ] },
  { country: 'SI', language: [ 'sl' ] },
  { country: 'SK', language: [ 'sk' ] },
  { country: 'TH', language: [ 'th', 'en' ] },
  { country: 'TR', language: [ 'tr' ] },
  { country: 'TW', language: [ 'zh' ] },
  { country: 'UA', language: [ 'uk', 'ru' ] },
  { country: 'UK', language: [ 'en' ] },
  { country: 'US', language: [ 'en' ] },
  { country: 'VN', language: [ 'vi', 'en' ] },
  { country: 'ZA', language: [ 'en' ] },
  { country: 'MX', language: [ 'es' ] },
];
